import Model from 'flarum/common/Model';
export default class Translation extends Model {
  translatableType() {
    return Model.attribute('translatableType').call(this);
  }
  translatableId() {
    return Model.attribute('translatableId').call(this);
  }
  language() {
    return Model.attribute('language').call(this);
  }
  field() {
    return Model.attribute('field').call(this);
  }
  value() {
    return Model.attribute('value').call(this);
  }
  provider() {
    return Model.attribute('provider').call(this);
  }
  updateNeeded() {
    return Model.attribute('updateNeeded').call(this);
  }
  editedBy() {
    return Model.hasOne('editedBy').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  updatedAt() {
    return Model.attribute('updatedAt', Model.transformDate).call(this);
  }
}
flarum.reg.add('glowingblue-translate', 'common/models/Translation', Translation);